// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"GY-z"};